export default __webpack_public_path__ + "static/media/Certificate_8.6b9f4553.jpg";